<template>
  <div class="content">
    <h1>Departments</h1>
    <TableContent :table-info="userTableInfo" name="departments"></TableContent>
  </div>
</template>

<script>
import TableContent from "@/Admin/components/TableContent.vue";
import EditAction from "@/Admin/components/form_actions/EditAction.vue";
import DeleteAction from "@/Admin/components/form_actions/DeleteAction.vue";

export default {
  name: "DepartmentListView",
  components: { TableContent },
  data: () => ({
    userTableInfo: {
      headers: [
        {
          title: "id",
          align: "start",
          sortable: false,
          key: "id",
        },
        {
          title: "Name",
          align: "start",
          key: "name",
        },
        {
          title: "Actions",
          align: "start",
          key: "actions",
        },
      ],
      actions: [EditAction, DeleteAction],
    },
  }),
};
</script>

<style scoped>
.content {
  width: 100%;
}
</style>
